module.exports = __webpack_public_path__ + "img/login-form-image.d5146007.png";